/* unplugin-vue-components disabled */import script from "./XTableColumn.vue?vue&type=script&setup=true&lang=ts"
export * from "./XTableColumn.vue?vue&type=script&setup=true&lang=ts"

import "./XTableColumn.vue?vue&type=style&index=0&id=2fb4556d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fb4556d"]])

export default __exports__